import React,{ useState, useEffect } from 'react'
import './Cart.css'
import { useCart } from './CartContext';
import { useNavigate  } from "react-router-dom";
import { useAuth } from '../firebase/AuthContext';
import CustomerCare from '../CustomerCare/CustomerCare';

function Cart() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const { cartItems, removeFromCart, incrementQuantity, decrementQuantity } = useCart();
  const { user, handleUserNavigation } = useAuth();
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const navigate = useNavigate();

  const CalculatePerItemTotalPrice = (item) => {
    return (item.price * item.quantity).toFixed(2);
  };

  const calculateFullTotalPrice = () => {
    return cartItems.reduce((total, item) => total + (item.price * item.quantity), 0).toFixed(2);
  };
 
  const handleCheckoutClick = () => {
    if (user) {  // Use the user object to check authentication
      if (cartItems.length === 0) {
        alert("Please add products to the cart before proceeding to checkout.");
      } else {
        navigate('/checkout');  // Utilize the existing navigation handler
      }
    } 
    else if(!user){
      if (cartItems.length === 0) {
      alert("Please add products to the cart before proceeding to checkout.");
      }
      else{
        // alert("Please log in first to proceed with checkout.");
        // handleUserNavigation();  // This will navigate to login if not logged in
        navigate('/checkout');
      }
    }
    // else{
    //   alert("Please log in first to proceed with checkout.");
    //   handleUserNavigation();  // This will navigate to login if not logged in
    // }
  };

  const handleProductClick = (Id) => {
    navigate(`/product_detail/${Id}`); // Navigate to the product detail page with the specific product ID
  };

  // const handleContinueShopping = () => {
  //   navigate('/'); // Navigate to the home page
  // };
  // const handleContinueShopping = (e) => {
  //   e.preventDefault(); // Prevent default link behavior
  //   navigate('/'); // Navigate to home page
  // };
  
  
  return (
    <>

 <div className="cart-container">
  <ul className="cart-list">
    {cartItems.map((item) => (
      <li key={item.id} className="cart-item" 
          onClick={() => handleProductClick(item.id)}>

        <img src={item.imageUrl[0]} alt="item-image" 
             
             className="cart-item-image" />

        
        <div className="cart-item-info">
          {/* <h4 className="cart-item-name">{item.name}</h4> */}
          <h4 className="cart-item-name">{item.title}</h4>
          <div className="cart-item-total">
              Rs. {(item.price * item.quantity).toFixed(2)}
          </div>
          <div className='cart-btn-container'
               onClick={(e) => {
                  e.stopPropagation(); // Prevent triggering the product click event
                }} >
            <button
              onClick={() => decrementQuantity(item)}
              className="cart-decrement-btn"
            >
              -
            </button>
            <span className="cart-quantity">{item.quantity}</span>
            <button
              onClick={() => incrementQuantity(item)}
              className="cart-increment-btn"
            >
              +
            </button>
            
          </div>
        </div>

        
        <i class="ri-delete-bin-6-line" 
            onClick={(e) => {
                  e.stopPropagation(); // Prevent triggering the product click event
                  removeFromCart(item)
                }}>
        </i>
      </li>
    ))}
  </ul>
  <div className='order-summary-container'>
    <div className='order-summary'>
      <h2 className='order-summary-header'>Order summary</h2>
      <div>
        <div className='sub-total'>
          <span> Subtotal </span>
          <span> Rs.{calculateFullTotalPrice()} </span>
        </div>
        <p className='calculate-taxes'>
          Taxes and shipping calculated at checkout
        </p>
      </div>
      <button onClick={handleCheckoutClick} className='check-out-button'>
        <i class="ri-lock-2-line"></i>
        Proceeding checkout 
      </button>
    </div>
  </div>
 
 </div>
  {/* <div onClick={handleContinueShopping} style={{ cursor: 'pointer' }} className='continue-shopping'>
    <p>
      <i className="ri-arrow-left-s-line"/>
      Continue shopping
    </p>
  </div> */}
  <a href="/"  className='continue-shopping'>
    <i className="ri-arrow-left-s-line" />
    Continue shopping
  </a>

    {/* <div className="subtotal-price-container">
        <span> Subtotal: Rs.{calculateFullTotalPrice()} </span>
         <button onClick={handleCheckoutClick} className='check-out-button'>
          <i class="ri-lock-2-line"></i>
          CheckOut 
        </button>
    </div> */}
    <CustomerCare />
    </>
  )
}
export default Cart;










// import React,{ useState, useEffect } from 'react'
// import './Cart.css'
// import { useCart } from './CartContext';
// import { useNavigate  } from "react-router-dom";
// import { useAuth } from '../firebase/AuthContext';

// function Cart() {
//   useEffect(() => {
//     window.scrollTo(0, 0);
//   }, []);

//   const { cartItems, removeFromCart, incrementQuantity, decrementQuantity } = useCart();
//   const { user, handleUserNavigation } = useAuth();
//   const [isLoggedIn, setIsLoggedIn] = useState(false);
//   const navigate = useNavigate();

//   const CalculatePerItemTotalPrice = (item) => {
//     return (item.price * item.quantity).toFixed(2);
//   };

//   const calculateFullTotalPrice = () => {
//     return cartItems.reduce((total, item) => total + (item.price * item.quantity), 0).toFixed(2);
//   };
 
//   const handleCheckoutClick = () => {
//     if (user) {  // Use the user object to check authentication
//       if (cartItems.length === 0) {
//         alert("Please add products to the cart before proceeding to checkout.");
//       } else {
//         navigate('/checkout');  // Utilize the existing navigation handler
//       }
//     } else {
//       handleUserNavigation();  // This will navigate to login if not logged in
//     }
//   };

//   const handleProductClick = (Id) => {
//     navigate(`/product_detail/${Id}`); // Navigate to the product detail page with the specific product ID
//   };
  
  
//   return (
//     <>
//     <div className="cart-container">
//       <table className="cart-table">
//         <thead>
//           <tr>
//             <th>#</th>
//             <th>Product</th>
//             <th>Price</th>
//             <th>Quantity</th>
//             <th>Per Item Total</th>
//             <th>Action</th>
//           </tr>
//         </thead>
//         <tbody>
//           {cartItems.map((item, index) => (
//             <tr key={index}>
//               <td>{index + 1}</td>
//               <td key={item.id}
//                   onClick={() => handleProductClick(item.id)} 
//                   style={{cursor:'pointer'}}>
//                     <img src={item.imageUrl} alt="item-image"/><br/>{item.name}
//               </td>
//               {/* <td>${item.price}</td> */}
//               <td>Rs.{Number(item.price).toFixed(2)}</td>
//               <td>
//                 <button onClick={() => decrementQuantity(item)} className='decrement-button'>-</button>
//                 {item.quantity}
//                 <button onClick={() => incrementQuantity(item)} className='increment-button'>+</button>
//               </td>
//               <td>{item.price} * {item.quantity} = {CalculatePerItemTotalPrice(item)}</td>
//               <td>
//                 <button onClick={() => removeFromCart(item)} className='remove-button'>Remove</button>
//               </td>
//             </tr>
//           ))}
//         </tbody>
//       </table>
//     </div>
//     <div className="subtotal-price-container">
//         Subtotal: Rs.{calculateFullTotalPrice()}
//         <br/>
//          <button onClick={handleCheckoutClick} className='check-out-button'>
//           <i className="ri-shopping-cart-2-line"></i>CheckOut
//         </button>
//     </div>
//     </>
//   )
// }
// export default Cart;
